export default __webpack_public_path__ + "static/media/abbevillemini.43394417.jpg";